const hi = {
  common: {
    home: "होम",
    materials: "सामग्री",
    rateCard: "रेट कार्ड",
    cart: "कार्ट",
    myBookings: "मेरी बुकिंग्स",
    login: "लॉगिन",
    signup: "साइन अप",
    dashboard: "डैशबोर्ड",
    settings: "सेटिंग्स",
    logout: "लॉगआउट",
    save: "सेव करें",
    loading: "लोड हो रहा है...",
  },
  header: {
    brand: "मिस्त्रीबाज़ार",
  },
  settings: {
    title: "सेटिंग्स",
    subtitle: "अपनी प्रोफाइल, भाषा, पता और अकाउंट प्राथमिकताएँ प्रबंधित करें।",
    profileSection: "प्रोफाइल",
    languageSection: "भाषा",
    addressSection: "सहेजा गया पता",
    accountSection: "अकाउंट",
    fullName: "पूरा नाम",
    phone: "फोन नंबर",
    email: "ईमेल",
    city: "शहर",
    preferredLanguage: "पसंदीदा भाषा",
    flatHouseNo: "फ्लैट नं / मकान नं",
    streetArea: "गली / क्षेत्र",
    state: "राज्य",
    country: "देश",
    pincode: "पिनकोड",
    role: "भूमिका",
    uniqueId: "यूनिक आईडी",
    saveProfile: "प्रोफाइल सेव करें",
    saveAddress: "पता सेव करें",
    accountDetails: "अकाउंट विवरण",
  },
  home: {
    heroTitle: "मिस्त्रीबाज़ार",
    heroText:
      "सेवाएँ बुक करें, सामग्री खरीदें, अपना घर बनाएं, और स्थानीय समन्वय, छिपी लागत और अनिश्चित समयसीमा की परेशानी कम करें।",
    buyMaterials: "सामग्री खरीदें",
    buildYourHouse: "अपना घर बनाएं",
    exploreMembership: "मेंबरशिप देखें",
    services: "सेवाएँ",
    about: "हमारे बारे में",
    contactUs: "संपर्क करें",
    privacyPolicy: "गोपनीयता नीति",
    terms: "नियम और शर्तें",
  },
};

export default hi;